import type { EnvironmentType } from "@octopusdeploy/octopus-server-client";
export type EnvironmentSelection = {
    type: EnvironmentType;
    environmentId: string;
    name: string;
};
export function getEnvironmentIds(environments: EnvironmentSelection[]) {
    return environments.map((e) => e.environmentId);
}
